/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Website_Feature_4Inputs */

const et_plan_website_feature_4 = /** @type {(inputs: Plan_Website_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hea veebileht aitab rohkematel inimestel sinuga ühendust võtta`)
};

const en_plan_website_feature_4 = /** @type {(inputs: Plan_Website_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A good website helps more people get in touch with you`)
};

/**
* | output |
* | --- |
* | "A good website helps more people get in touch with you" |
*
* @param {Plan_Website_Feature_4Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_website_feature_4 = /** @type {((inputs?: Plan_Website_Feature_4Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Website_Feature_4Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_website_feature_4(inputs)
	return en_plan_website_feature_4(inputs)
});